import CryptoJS from "crypto-js";


export const encryptData = (data, secretKey) => {
    try {
        const ciphertext = CryptoJS.AES.encrypt(
            data,
            secretKey
        ).toString();
        return ciphertext;
    } catch (error) {
        console.error("Encryption failed:", error);
        throw new Error("Encryption failed");
    }
}